import {createSlice} from '@reduxjs/toolkit';

import MojitoCore from 'mojito/core';

const reduxInstance = MojitoCore.Services.redux;

export const STORE_KEY = 'aliraStore';

export const INITIAL_STATE = {
    loginInfo: undefined,
};

export const {reducer, actions} = createSlice({
    name: 'alira',
    initialState: INITIAL_STATE,
    reducers: {
        loginSuccess(state, {payload: loginInfo}) {
            state.loginInfo = loginInfo;
        },
        loginFailed(state) {
            state.loginInfo = undefined;
        },
    },
});

reduxInstance.injectReducer(STORE_KEY, reducer);
